import { render, staticRenderFns } from "./CompanyAward.vue?vue&type=template&id=693cd250"
import script from "./CompanyAward.vue?vue&type=script&lang=js"
export * from "./CompanyAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports